// 用户中心-用户账号集合+零散小功能操作板块
const UserHomeRouterMap = [
  // 用户中心页面集合
  {
    path: '/user/user-center',
    component: UserCenter => (require(['@/views/user/userCenter'], UserCenter))
  },
  // 用户收货地址
  {
    path: '/user/address',
    component: Address => (require(['@/views/user/address'], Address))
  },
  // 用户准备清单
  {
    path: '/user/readylist',
    component: Readylist => (require(['@/views/user/readylist'], Readylist))
  },
  // 防疫公告
  {
    path: '/user/epidemic',
    component: Readylist => (require(['@/views/user/epidemic'], Readylist))
  },
  // 行程调整通知
  {
    path: '/user/modification',
    component: UserCenter => (require(['@/views/user/modification'], UserCenter))
  }
]

export default UserHomeRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/home.js